import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-20 px-6 bg-muted-blue/5 border-y border-muted-blue/10" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-88">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-8 leading-tight" data-id="element-89">
            You deserve a house that doesn't run on your last nerve.
          </h2>

          <a href="#checkout" onClick={e => {
          e.preventDefault();
          const target = document.getElementById('checkout');
          if (!target) return;
          const start = window.scrollY;
          const end = target.getBoundingClientRect().top + window.scrollY - 20;
          const duration = 2000;
          const startTime = performance.now();
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }} className="group inline-flex items-center justify-center gap-3 bg-muted-blue hover:bg-muted-blue-dark text-white text-lg font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-90">
            <span data-id="element-91">
              Get the Reset —{' '}
              <span className="line-through opacity-60 font-normal" data-id="element-92">$27</span>{' '}
              $6.36
            </span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-93" />
          </a>
        </motion.div>
      </div>
    </section>;
}